import Component from "../../lib/Component.js";
// import { withDevModeFailover } from "../helpers.js";

const TonefuseAds = ({ preloadScriptId, _consentPromise }) => {
  let mounted = false;

  const tonefuseAdZones = document.querySelectorAll("[id^='amplified_']");

  const loadTonefuseScript = async () => {
    /* We don't use consent since Tonefuse banners are not personalized */
    /* const { ads } = await withDevModeFailover(consentPromise, { ads: true });
    if (!ads) {
      tonefuseAdZones.forEach((el) => el.parentElement.remove());
      return;
    } */

    const adUnitIds = Array.from(tonefuseAdZones)
      .map((el) => parseInt(el.id.replace("amplified_", ""), 10))
      .filter((id) => !isNaN(id));
    if (process.env.NODE_ENV === "development") {
      console.log("[Tonefuse] found ad units:", adUnitIds);
    }

    let tonefuseScriptPreload = document.getElementById(preloadScriptId);
    if (tonefuseScriptPreload) {
      window.amplified = window.amplified || { init: [] };
      window.amplified.init.push(function () {
        if (adUnitIds.length === 0) return;

        window.amplified.setParams({
          tv_term: "",
        });
        adUnitIds.forEach((adUnitId) => {
          window.amplified.pushAdUnit(adUnitId);
        });
        window.amplified.run();
      });

      const tonefuseScript = document.createElement("script");
      document.querySelector("body").appendChild(tonefuseScript);
      tonefuseScript.onload = () => {
        if (process.env.NODE_ENV === "development") {
          console.log("[Tonefuse] Script loaded successfully");
        }
      };
      tonefuseScript.onerror = () => {
        if (process.env.NODE_ENV === "development") {
          console.log("[Tonefuse] Script failed to load");
        }
        tonefuseAdZones.forEach((el) => el.parentElement.remove());
      };
      tonefuseScript.src = tonefuseScriptPreload.href;
    }
  };

  return tonefuseAdZones.length > 0
    ? new Component({
        onMount: async () => {
          if (mounted) return;
          mounted = true;

          loadTonefuseScript();
        },
      })
    : Component.noop();
};

export default TonefuseAds;
